export const colorsBackground = []
export const colorsFonts = []
